//index.js
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { StyledEngineProvider } from "@mui/material/styles";
import AppThemeProvider from "./AppThemeProvider";
import { applyCssColorVariables } from "./theme/tokens/cssColorVariables";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./Redux/store";

// Bootstrap derived CSS colour vars before first paint (SSoT: tokens/colors.js)
const bootThemeMode =
  localStorage.getItem("themeMode") === "dark" ? "dark" : "light";
applyCssColorVariables(bootThemeMode);
if (bootThemeMode === "dark") {
  document.body.classList.add("dark-mode");
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop />
      <PersistGate persistor={persistor}>
        <StyledEngineProvider injectFirst>
          <AppThemeProvider>
            <App />
          </AppThemeProvider>
        </StyledEngineProvider>
      </PersistGate>
    </BrowserRouter>
  </Provider>
);

reportWebVitals();

// Prefer importing from ./Redux/store — kept for any legacy default import of store.
export default store;
